export const SET_DATA = 'SET_DATA';